const locatore = "locatore";
const conduttore = "conduttore";

//
function clusterSorterFunction(a, b) {
  if (a.name?.toLowerCase() === locatore) {
    return -1; // a comes before b
  } else if (b.name?.toLowerCase() === locatore) {
    return 1; // b comes before a
  } else if (a.name?.toLowerCase() === conduttore) {
    return -1; // a comes before b
  } else if (b.name?.toLowerCase() === conduttore) {
    return 1; // b comes before a
  } else {
    return a.name.localeCompare(b.name); // normal lexicographic sorting
  }
}

//
export function sortClusters(clusters) {
  return (clusters ?? []).sort(clusterSorterFunction);
}
